import { useForm } from "react-hook-form";
import {
  PageWrapper,
  Header,
  ButtonGroup,
  Button,
  Card,
  CardTitle,
  Grid,
  Field,
  Label,
  Input,
  TextArea,
} from "../../style/admin/settingform.style";
import { ESettingResponse } from "../../models/setting";
import { useEffect, useState } from "react";
import SettingService from "../../services/api/setting.service";
import { toast } from "../../utils/notify";
import QuillEditor from "../../components/QuillEditor";
import TiptapEditor from "../../components/TipTapEditor";

const SettingForm = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<ESettingResponse>({
    defaultValues: {},
  });
  const [setting, setSetting] = useState<ESettingResponse | null>(null);
  const [editorValue, setEditorValue] = useState(""); // ⭐ state riêng cho editor

  const getSetting = async () => {
    var res = await SettingService.getSingle();

    if (res.success) {
      setSetting(res.data);
      reset({
        ...res.data,
        schema: res.data.schema
          ? JSON.stringify(JSON.parse(res.data.schema), null, 2)
          : "",
      });

      setEditorValue(res.data.footer);
    }
  };
  useEffect(() => {
    getSetting();
  }, []);

  const onSubmit = async (data: ESettingResponse) => {
    if (data.schema) {
      try {
        JSON.parse(data.schema);
      } catch {
        toast("Schema JSON không hợp lệ", "error");
        return;
      }
    }
    data.footer = editorValue;
    var res = await SettingService.createOrUpdate(data);

    if (res.success) {
      toast(res.message, "success");
    } else {
      toast(res.message, "error");
    }
  };

  return (
    <PageWrapper>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Header>
          <div />
          <ButtonGroup>
            <Button type="submit">Lưu</Button>
            <Button type="button" className="cancel" onClick={() => reset()}>
              Làm lại
            </Button>
          </ButtonGroup>
        </Header>

        <Card>
          <CardTitle>Thông Tin Chung</CardTitle>

          <Grid>
            <Field>
              <Label>Email</Label>
              <Input
                {...register("email", {
                  //required: "Email không được để trống",
                })}
              />
              {errors.email && (
                <small style={{ color: "red" }}>{errors.email.message}</small>
              )}
            </Field>

            <Field>
              <Label>Hotline 1</Label>
              <Input {...register("hotline")} />
            </Field>

            <Field>
              <Label>Zalo</Label>
              <Input {...register("zalo")} />
            </Field>

            <Field>
              <Label>OAID Zalo</Label>
              <Input {...register("oaidZalo")} />
            </Field>

            <Field>
              <Label>Website</Label>
              <Input {...register("website")} />
            </Field>

            <Field>
              <Label>Fanpage</Label>
              <Input {...register("fanpage")} />
            </Field>

            <Field>
              <Label>Link Instagram</Label>
              <Input {...register("instagram")} />
            </Field>

            <Field>
              <Label>Link Google Map</Label>
              <Input {...register("googleMap")} />
            </Field>

            <Field>
              <Label>Tiktok</Label>
              <Input {...register("tiktok")} />
            </Field>
          </Grid>

          <Field style={{ marginTop: 16 }}>
            <Label>Lượt preview</Label>
            <Input
              type="number"
              {...register("numberOfTranslationServicesUsed")}
            />
          </Field>

          <Field style={{ marginTop: 16 }}>
            <Label>Số kí tự được phép dịch</Label>
            <Input type="number" {...register("numberOfCharacters")} />
          </Field>

          <Field style={{ marginTop: 16 }}>
            <Label>Giờ hoạt động</Label>
            <Input {...register("workingTime")} />
          </Field>

          <Field style={{ marginTop: 16 }}>
            <Label>Slogan</Label>
            <Input {...register("slogan")} />
          </Field>

          <Field style={{ marginTop: 16 }}>
            <Label>Tọa độ google map iframe</Label>
            <TextArea {...register("mapIframe")} />
          </Field>

          <Field style={{ marginTop: 16 }}>
            <Label>Google Analytics</Label>
            <TextArea {...register("googleAnalytics")} />
          </Field>

          <Field style={{ marginTop: 16 }}>
            <Label>Google Webmaster Tool</Label>
            <TextArea {...register("googleWebmaster")} />
          </Field>

          <Field style={{ marginTop: 16 }}>
            <Label>Schema</Label>
            <TextArea
              {...register("schema", {
                validate: (value) => {
                  if (!value) return true;

                  try {
                    const json = JSON.parse(value);

                    if (!json["@context"]) {
                      return "Schema thiếu @context";
                    }

                    if (!json["@type"]) {
                      return "Schema thiếu @type";
                    }

                    return true;
                  } catch {
                    return "Schema phải là JSON hợp lệ";
                  }
                },
              })}
              spellCheck={false}
              style={{
                fontFamily: "monospace",
                minHeight: 220,
                whiteSpace: "pre",
              }}
            />

            {errors.schema && (
              <small style={{ color: "red" }}>{errors.schema.message}</small>
            )}
          </Field>
        </Card>

        <Card style={{ marginTop: 16 }}>
          <CardTitle>Thông Tin Khác</CardTitle>

          <Grid>
            {/* <Field>
              <Label>Tiêu đề</Label>
              <Input
                {...register("title", {
                  //required: "Tiêu đề không được để trống",
                })}
              />
              {errors.title && (
                <small style={{ color: "red" }}>{errors.title.message}</small>
              )}
            </Field> */}

            <Field style={{ marginTop: 16 }}>
              <Label>Địa chỉ</Label>
              <Input {...register("address")} />
            </Field>

            {/* <Field>
              <Label>Link-Admin</Label>
              <Input {...register("linkAdmin")} />
            </Field> */}
          </Grid>
          <Field style={{ marginTop: 16 }}>
            <Label>Head Script Js</Label>
            <TextArea {...register("headScriptJs")} />
          </Field>
          <Field style={{ marginTop: 16 }}>
            <Label>Body Script Js</Label>
            <TextArea {...register("bodyScriptJs")} />
          </Field>
          <Field style={{ marginTop: 16 }}>
            <Label>Body No Script Js</Label>
            <TextArea {...register("bodyNoScriptJs")} />
          </Field>
          <Field style={{ marginTop: 16 }}>
            <Label>Fanpage Js</Label>
            <TextArea {...register("fanpageJs")} />
          </Field>
          <Field style={{ marginTop: 16 }}>
            <Label>Footer</Label>
            {/* <QuillEditor
              height={1000}
              value={editorValue}
              onChange={setEditorValue}
            /> */}
            <TiptapEditor
              value={editorValue}
              onChange={setEditorValue}
              height={1000}></TiptapEditor>
          </Field>
        </Card>
      </form>
    </PageWrapper>
  );
};

export default SettingForm;
